/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import BJB from "../../../assets/images/sponsor/Bank_BJB_logo.png";
import LogoPemkot from "../../../assets/images/sponsor/logo-pemkot.png";
import Kompas from "../../../assets/images/sponsor/kompas.png";
import LogoLeMinerale from "../../../assets/images/sponsor/logo-le-minerale.png";
import LogoIsoplus from "../../../assets/images/sponsor/logo-isoplus.jpg";
import LogoHydroCoco from "../../../assets/images/sponsor/logo-hydro-coco.png";
import LogoGenerali from "../../../assets/images/sponsor/logo-generali.jpg";
import LogoMyPertamina from "../../../assets/images/sponsor/logo-my-pertamina.png";
import LogoAsics from "../../../assets/images/sponsor/logo-asics.png";
import LogoEJSport from "../../../assets/images/sponsor/logo-ej-sport.png";
import LogoZinc from "../../../assets/images/sponsor/logo-zinc.png";
import LogoAzzura from "../../../assets/images/sponsor/logo-azzura.png";
import LogoCiptadentFresh from "../../../assets/images/sponsor/logo-ciptadent-fresh.png";
import LogoPosh from "../../../assets/images/sponsor/logo-posh.png";
import LogoFitbar from "../../../assets/images/sponsor/logo-fitbar.png";
import LogoPilkitaHerbal from "../../../assets/images/sponsor/logo-pilkita-herbal.png";
import LogoAntangin from "../../../assets/images/sponsor/logo-antangin.png";
import LogoHotelSantika from "../../../assets/images/sponsor/logo-hotel-santika.png";
import LogoCardea from "../../../assets/images/sponsor/logo-cardea.jpg";
import LogoZoll from "../../../assets/images/sponsor/logo-zoll.png";
import LogoShokz from "../../../assets/images/sponsor/logo-shokz.png";
import LogoGarmin from "../../../assets/images/sponsor/logo-garmin.png";
import LogoDuraking from "../../../assets/images/sponsor/logo-duraking.png";
// import LogoNomadGrounds from "../../../assets/images/sponsor/logo-nomad-grounds.png";
import LogoByd from "../../../assets/images/sponsor/logo-byd.png";
import LogoRsHermina from "../../../assets/images/sponsor/logo-rs-hermina.png";
import LogoRsMayapada from "../../../assets/images/sponsor/logo-rs-mayapada.png";
import LogoHotInCream from "../../../assets/images/sponsor/logo-hot-in-cream.png";
import LogoAmh from "../../../assets/images/sponsor/logo-amh.png";
import LogoTehPucukLessSugar from "../../../assets/images/sponsor/logo-teh-pucuk-less-sugar.png";
import LogoFitHub from "../../../assets/images/sponsor/logo-fithub.jpeg";
import LogoHotelGoldenTulip from "../../../assets/images/sponsor/logo-hotel-golden-tulip.png";
import LogoWargaKota from "../../../assets/images/sponsor/logo-warga-kota.png";
import LogoCeritaPelari from "../../../assets/images/sponsor/logo-cerita-pelari.png";
import LogoKalenderLari from "../../../assets/images/sponsor/logo-kalender-lari.png";
import LogoTngTv from "../../../assets/images/sponsor/logo-tng-tv.png";
import LogoStaradi from "../../../assets/images/sponsor/logo-staradi.png";

import { useTranslation } from "react-i18next";

export default function Sponsor() {
    const { t } = useTranslation();
    return (
        <div className="bg-white font-poppins uppercase py-10">
            <div className="hidden">
                <div className="relative container w-full mx-auto py-20 2xl:py-24 grid grid-cols-1">
                    <div className="grid md:grid-cols-3 uppercase gap-4 2xl:gap-10 py-0">
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.manage")}</h2>
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.powered")}</h2>
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.govt")}</h2>
                        </div>
                    </div>
                    <div className="grid md:grid-cols-3 uppercase gap-4 2xl:gap-10 py-0">
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <a href="https://www.kompas.id/" target="_blank" rel="noreferrer">
                                <img src={Kompas} alt="logo-kompas" className="w-56 xl:w-64" />
                            </a>
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <a href="https://bankbjb.co.id/" target="_blank" rel="noreferrer">
                                <img src={BJB} alt="logo-bjb" className="w-36 xl:w-48" />
                            </a>
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <div className="flex h-full items-center justify-center gap-x-8">
                                <a href="https://tangerangkota.go.id/" target="_blank" rel="noreferrer">
                                    <img src={LogoPemkot} alt="logo-pemkot" className="w-20 xl:w-28 xl:pt-4" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="md:block">
                <div className="relative container w-full mx-auto py-20 2xl:py-24 grid grid-cols-1">
                    <div className="grid md:grid-cols-3 uppercase gap-y-16">
                        <div className="order-2 md:order-1 space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.powered")}</h2>
                            <a href="https://bankbjb.co.id/" target="_blank" rel="noreferrer">
                                <img src={BJB} alt="logo-bjb" className="w-36 xl:w-48" />
                            </a>
                        </div>
                        <div className="order-1 md:order-2 space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.manage")}</h2>
                            <a href="https://www.kompas.id/" target="_blank" rel="noreferrer">
                                <img src={Kompas} alt="logo-kompas" className="w-56 xl:w-64 pt-4 md:pt-12" />
                            </a>
                        </div>
                        <div className="order-3 space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.govt")}</h2>
                            <div className="flex h-full items-center justify-center gap-x-8">
                                <a href="https://tangerangkota.go.id/" target="_blank" rel="noreferrer">
                                    <img src={LogoPemkot} alt="logo-pemkot" className="w-20 xl:w-28 xl:pt-4" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="relative container w-full mx-auto py-0">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-y-16 gap-x-8 uppercase">
                        <div className="flex flex-col justify-start items-center">
                            <div className="h-12 md:h-16 flex items-center justify-center text-center mb-4">
                                <h2 className="text-base lg:text-xl font-normal">{t("footer.mineral")}</h2>
                            </div>
                            <div className="h-24 md:h-32 flex items-center justify-center">
                                <a href="https://www.leminerale.com/" target="_blank" rel="noreferrer">
                                    <img src={LogoLeMinerale} alt="logo-le-minerale" className="w-44 xl:w-56 max-h-full object-contain" />
                                </a>
                            </div>
                        </div>
                        <div className="flex flex-col justify-start items-center">
                            <div className="h-12 md:h-16 flex items-center justify-center text-center mb-4">
                                <h2 className="text-base lg:text-xl font-normal">{t("footer.isotonic")}</h2>
                            </div>
                            <div className="h-24 md:h-32 flex items-center justify-center">
                                <a href="https://wingscorp.com/brand-detail/isoplus/" target="_blank" rel="noreferrer">
                                    <img src={LogoIsoplus} alt="logo-isoplus" className="w-48 xl:w-56 max-h-full object-contain" />
                                </a>
                            </div>
                        </div>
                        <div className="flex flex-col justify-start items-center">
                            <div className="h-12 md:h-16 flex items-center justify-center text-center mb-4">
                                <h2 className="text-base lg:text-xl font-normal">{t("footer.insurance")}</h2>
                            </div>
                            <div className="h-24 md:h-32 flex items-center justify-center">
                                <a href="https://www.generali.co.id/" target="_blank" rel="noreferrer">
                                    <img src={LogoGenerali} alt="logo-generali" className="w-48 xl:w-56 max-h-full object-contain" />
                                </a>
                            </div>
                        </div>
                        <div className="flex flex-col justify-start items-center">
                            <div className="h-12 md:h-16 flex items-center justify-center text-center mb-4">
                                <h2 className="text-base lg:text-xl font-normal">{t("footer.healthydrink")}</h2>
                            </div>
                            <div className="h-24 md:h-32 flex items-center justify-center">
                                <a href="https://hydrococo.com/" target="_blank" rel="noreferrer">
                                    <img src={LogoHydroCoco} alt="logo-hydro-coco" className="w-48 xl:w-56 max-h-full object-contain" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="relative container w-full mx-auto pt-20 pb-10 grid grid-cols-1">
                    <div className="grid md:grid-cols-3 uppercase gap-y-16">
                        <div className="space-y-4 flex flex-col justify-start items-center col-span-3">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.cosponsor")}</h2>
                            <div className="grid grid-cols-2 md:grid-cols-7 place-content-center items-center md:gap-x-8 gap-x-4 px-8">
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.pertamina.com/" target="_blank" rel="noreferrer">
                                        <img src={LogoMyPertamina} alt="logo-my-pertamina" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://asics.co.id/" target="_blank" rel="noreferrer">
                                        <img src={LogoAsics} alt="logo-asics" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://ejsportofficial.com/" target="_blank" rel="noreferrer">
                                        <img src={LogoEJSport} alt="logo-ej-sport" className="max-h-16 md:max-h-20 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.zinc.co.id/" target="_blank" rel="noreferrer">
                                        <img src={LogoZinc} alt="logo-zinc" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://azzuracosmetics.com/" target="_blank" rel="noreferrer">
                                        <img src={LogoAzzura} alt="logo-azzura" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="http://www.ciptadent.co.id/" target="_blank" rel="noreferrer">
                                        <img src={LogoCiptadentFresh} alt="logo-ciptadent-fresh" className="max-h-16 md:max-h-20 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.poshindonesia.id/" target="_blank" rel="noreferrer">
                                        <img src={LogoPosh} alt="logo-posh" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 md:grid-cols-9 place-content-center items-center md:gap-x-8 gap-x-4 px-8">
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://kalbenutritionals.com/id/produk-kami/fitbar" target="_blank" rel="noreferrer">
                                        <img src={LogoFitbar} alt="logo-fitbar" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.deltomed.id/our-brands/pilkita-1" target="_blank" rel="noreferrer">
                                        <img src={LogoPilkitaHerbal} alt="logo-pilkita-herbal" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.deltomed.id/our-brands/antangin" target="_blank" rel="noreferrer">
                                        <img src={LogoAntangin} alt="logo-antangin" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.mysantika.com/" target="_blank" rel="noreferrer">
                                        <img src={LogoHotelSantika} alt="logo-hotel-santika" className="max-h-16 md:max-h-20 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="#" target="_blank" rel="noreferrer">
                                        <img src={LogoDuraking} alt="logo-duraking" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://cardea.asia/" target="_blank" rel="noreferrer">
                                        <img src={LogoCardea} alt="logo-cardea" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.instagram.com/nomadgrounds_/" target="_blank" rel="noreferrer">
                                        <img src={LogoZoll} alt="logo-zoll" className="max-h-16 md:max-h-20 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://asia.shokz.com/" target="_blank" rel="noreferrer">
                                        <img src={LogoShokz} alt="logo-shokz" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="https://www.garmin.co.id/" target="_blank" rel="noreferrer">
                                        <img src={LogoGarmin} alt="logo-garmin" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 md:grid-cols-8 place-content-center items-center md:gap-x-8 gap-x-4 px-8">
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <img src={LogoByd} alt="logo-byd" className="max-h-16 md:max-h-20 w-auto object-contain" />
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <img src={LogoRsHermina} alt="logo-rs-hermina" className="max-h-16 md:max-h-20 w-auto object-contain" />
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <img src={LogoRsMayapada} alt="logo-rs-mayapada" className="max-h-16 md:max-h-20 w-auto object-contain" />
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <img src={LogoHotInCream} alt="logo-hot-in-cream" className="max-h-16 md:max-h-20 w-auto object-contain" />
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <img src={LogoAmh} alt="logo-amh" className="max-h-16 md:max-h-20 w-auto object-contain" />
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <img src={LogoTehPucukLessSugar} alt="logo-teh-pucuk-less-sugar" className="max-h-16 md:max-h-20 w-auto object-contain" />
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <img src={LogoFitHub} alt="logo-fithub" className="max-h-16 md:max-h-20 w-auto object-contain" />
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <img src={LogoHotelGoldenTulip} alt="logo-hotel-golden-tulip" className="max-h-16 md:max-h-20 w-auto object-contain" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="relative container w-full mx-auto pt-10 pb-20 grid grid-cols-1">
                    <div className="grid md:grid-cols-3 uppercase gap-y-16">
                        <div className="space-y-4 flex flex-col justify-start items-center col-span-3">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.mediapartner")}</h2>
                            <div className="grid grid-cols-2 md:grid-cols-5 place-content-center items-center md:gap-x-8 gap-x-4 px-8">
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="#" target="_blank" rel="noreferrer">
                                        <img src={LogoWargaKota} alt="logo-warga-kota" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="#" target="_blank" rel="noreferrer">
                                        <img src={LogoCeritaPelari} alt="logo-cerita-pelari" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="#" target="_blank" rel="noreferrer">
                                        <img src={LogoKalenderLari} alt="logo-kalender-lari" className="max-h-16 md:max-h-20 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="#" target="_blank" rel="noreferrer">
                                        <img src={LogoTngTv} alt="logo-tng-tv" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                                <div className="flex items-center justify-center h-24 md:h-32">
                                    <a href="#" target="_blank" rel="noreferrer">
                                        <img src={LogoStaradi} alt="logo-staradi" className="max-h-12 md:max-h-16 w-auto object-contain" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
